import { request } from '@app/http/request'
import { appConfig } from '@app/shared/config'
import { searchParamsToQuery } from '@app/utils/url'
import type { PaginatedListResponse } from '@backend-models/common/paging/paginated-list-response'

import type { SpResponse } from '@backend-models/common/request/sp-response'
import type { NavigationItemDto } from '@backend-models/navigation/navigation-item-dto'
import type { UpsertNavigationItemRequest } from '@backend-models/navigation/upsert-navigation-item/upsert-navigation-item-request'
import type { ListNavigationItemsRequest } from '@backend-models/navigation/list-navigation-items/list-navigation-items-request'
import type { GetNavigationItemByIdResponse } from "@backend-models/navigation/get-navigation-item-by-id-response.ts";
import type {
    UpsertNavigationItemResponse
} from "@backend-models/navigation/upsert-navigation-item/upsert-navigation-item-response.ts";
import type { ReorderNavigationItemsRequest } from '@backend-models/navigation/reorder-navigation-items/reorder-navigation-items-request'
import type { GetUserNavigationMenuItemDto } from '@backend-models/navigation/get-user-navigation-menu/get-user-navigation-menu-item-dto'

export const getNavigationItems = async (params?: ListNavigationItemsRequest): Promise<PaginatedListResponse<NavigationItemDto>> => {
  try {
    const query = searchParamsToQuery({ ...params })
    const req = await request(`${appConfig.api}/navigation${query}`, { auth: true })
    const res = await req.json()
    return res
  } catch (error) {
    console.error(error)
    return { data: [], success: false, page: 0, pageCount: 0, pageSize: 0, totalItems: 0 }
  }
}

export const getAllNavigationItems = async (): Promise<NavigationItemDto[]> => {
  try {
    const response = await getNavigationItems({ pageSize: 1000, page: 1 })
    return response.data || []
  } catch (error) {
    console.error(error)
    return []
  }
}

export const getNavigationItem = async (id: string): Promise<SpResponse<GetNavigationItemByIdResponse | null>> => {
  try {
    const req = await request(`${appConfig.api}/navigation/${id}`, { auth: true })
    const res = await req.json()
    return res
  } catch (error) {
    console.error(error)
    return { data: null, success: false }
  }
}

export const upsertNavigationItem = async (data: UpsertNavigationItemRequest, hideLoading = false): Promise<SpResponse<UpsertNavigationItemResponse | null>> => {
  try {
    const req = await request(`${appConfig.api}/navigation`, {
      auth: true,
      json: true,
      method: 'POST',
      body: JSON.stringify(data),
      hideLoading
    })
    const res = await req.json()
    return res
  } catch (error) {
    console.error(error)
    return { data: null, success: false }
  }
}

export const reorderNavigationItems = async (data: ReorderNavigationItemsRequest): Promise<SpResponse<boolean>> => {
  try {
    const req = await request(`${appConfig.api}/navigation/reorder`, { auth: true, method: 'POST', json: true, body: JSON.stringify(data) })
    const res = await req.json()
    return res
  } catch (error) {
    console.error(error)
    return { data: false, success: false }
  }
}

export const deleteNavigationItem = async (id: string): Promise<SpResponse<boolean>> => {
  try {
    const req = await request(`${appConfig.api}/navigation/${id}`, { auth: true, method: 'DELETE' })
    const res = await req.json()
    return res
  } catch (error) {
    console.error(error)
    return { data: false, success: false }
  }
}

export const getNavigationMenu = async (hideLoading = false): Promise<SpResponse<GetUserNavigationMenuItemDto[]>> => {
  try {
    const req = await request(`${appConfig.api}/navigation/menu`, { auth: true, hideLoading })
    const res = await req.json()
    return res
  } catch (error) {
    console.error(error)
    return { data: [], success: false }
  }
}
